import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {EventEmitter, Injectable} from '@angular/core';
import {CommandService} from '@core/services/command.service';
import {take} from 'rxjs/operators';
import {FileManagementService} from '@core/services/file-management.service';
import {SnackBarService} from '@core/services/snack-bar.service';

@Injectable({
  providedIn: 'root',
})

export class PublisherGridHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  constructor(private commandService: CommandService,
              private fileManagementService: FileManagementService,
              private snackBarService: SnackBarService) {}

  destroy(): void {
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
    console.log('command executing ', command);
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
      console.log(response);
      this.invalidateSubject.invalidate();
    });
  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged($event) {
    console.log('Inside valueChanged event ', $event);
    if ($event?.action?.id === 'DownloadMetaData') {
      this.downloadMetaData($event.item?.cells?.MetaDataId?.value);
    } else if ($event?.action?.id === 'UploadMetaData') {
      const uploadCommand = new PlatformCommand('UploadFileTaxFormDialogCommand', 'TaxFormApi');
      this.executeCommand(uploadCommand);
    } else if (($event?.action?.id === 'DeleteTaxForm')) {
      const deletePublisherItemCommand = new PlatformCommand('DeleteTaxFormPublisherModelCommand', 'TaxFormApi');
      deletePublisherItemCommand.fieldValues['PublisherItemId'] = $event.item?.id;
      this.executeCommand(deletePublisherItemCommand);
    }
  }

  private downloadMetaData(fileId: string) {
    if (fileId == null) {
      this.snackBarService.showError('This is a MetaData zip file or MetaData is not available');
      return; }
    this.fileManagementService.downloadFileWithId(fileId)
      .pipe(take(1)).subscribe(value => {
      this.fileManagementService.openSaveFileWindow(value, fileId);
    });
  }
}
